import { createContext, useReducer } from "react";

export const FoodPhotosContext = createContext();

export const foodPhotosReducer = (state, action) => {
    switch (action.type) {
        case 'SET_FOOD_PHOTOS':
            return {
                foodPhotos: action.payload
            }
        case 'CREATE_FOOD_PHOTOS':
            return {
                foodPhotos: [action.payload, ...state.foodPhotos]
            }
        case 'DELETE_FOOD_PHOTOS':
            return {
                foodPhotos: state.foodPhotos.filter(a => a._id !== action.payload._id)
            }
        default:
            return state
    };
};

export const FoodPhotosContextProvider = ({ children }) => {
    const [state, dispatch] = useReducer(foodPhotosReducer, {
        foodPhotos: null
    });

    return (
        <FoodPhotosContext.Provider value={{ ...state, dispatch }}>
            {children}
        </FoodPhotosContext.Provider>
    );
};